import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorPanel, EditorColumn} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {ImageUploader, VideoUploader} from '../uploaders';
import RichTextArea from '../rich-text-area/rich-text-area';

export default class ShowFundraising extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {fundraising: {}}
    this.dataURL = props.dataURL + '/fundraising';
    this.handleRichTextChange = this.handleRichTextChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.dataURL, 'fundraising');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('fundraising');
  }
  /** @function handleChange
    * Updates the state of the component based on
    * input field events.
    * @param {InputEvent} event - the event to respond to
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var fundraising = this.state.fundraising;
    fundraising[name] = value;
    this.setState({
      fundraising: fundraising
    });
  }
  handleRichTextChange(html) {
    firebase.database().ref(this.dataURL).child('message').set(html);
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur(event) {
    firebase.database().ref(this.dataURL).set(this.state.fundraising);
  }
  /** @function handleImageUpload
    * Applies uploaded images to the state and
    * saves them to the database.
    */
  handleImageUpload(name, url) {
    var fundraising = this.state.fundraising;
    fundraising[name] = url;
    this.setState({
      fundraising: fundraising
    }, () => this.handleBlur());
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <EditorPanel>
        <EditorColumn>
          <div className="input-group">
            <VideoUploader
              name="Fundraising Video"
              value={this.state.fundraising.video}
              dataURL={this.props.dataURL + '/video'}
              onUpload={(url)=>this.handleImageUpload('video', url)}
              />
          </div>
        </EditorColumn>
        <EditorColumn>
          <RichTextArea
            name="message"
            value={this.state.fundraising.message}
            onChange={this.handleRichTextChange}
            />
          <div className="input-group">
            <ImageUploader
              name="Fundraising Message Image"
              value={this.state.fundraising.image}
              dataURL={this.props.dataURL + '/image'}
              onUpload={(url)=>this.handleImageUpload('image', url)}
              />
          </div>
        </EditorColumn>
      </EditorPanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-fundraising.js